import React from "react";
import moment from "moment";
import TemporaryClosure from "./temporary-closure";
import * as Buttons from "@library/Buttons";
import * as c from "@/listing/hours/constants";

type Closure = {
  id?: number;
  start_date: string;
  end_date: string | null;
  reason: string;
};

type Props = {
  temporaryClosures: Closure[];
  setTemporaryClosures: (temporaryClosures: Closure[]) => void;
};

const TemporaryClosures = (props: Props) => {
  const closures = props.temporaryClosures;
  const today = () => moment().format(c.EDIT_DATE_FORMAT);

  const add = (closure: Closure) =>
    props.setTemporaryClosures([...closures, closure]);

  const update = (index: number, closure: Closure) =>
    props.setTemporaryClosures(
      closures.map((existing, i) => (i === index ? closure : existing))
    );

  const remove = (index: number) =>
    props.setTemporaryClosures(closures.filter((_, i) => i !== index));

  return (
    <div className="listing-status__temporary-closures">
      <div className="editor__listing__hours__card__header">
        <div>
          <h4 className="editor__listing__hours__card__title">
            {c.TEMPORARY_CLOSURES_LABEL}
          </h4>
          <div className="editor__listing__hours__card__subtitle">
            {c.TEMPORARY_CLOSURES_DESCRIPTION}
          </div>
        </div>
        <div className="editor__listing__hours__card__actions">
          <Buttons.WhiteButton
            cy="closed-today"
            onClick={() =>
              add({start_date: today(), end_date: today(), reason: "other"})}
          >
            {"Closed today"}
          </Buttons.WhiteButton>
          <Buttons.PrimaryButton
            cy="add-closure"
            onClick={() =>
              add({start_date: today(), end_date: null, reason: "other"})}
          >
            {"+ Add closure"}
          </Buttons.PrimaryButton>
        </div>
      </div>

      {closures.length > 0 && (
        <div className="listing-status__temporary-closures__headings">
          <span>{"From"}</span>
          <span>{"Through"}</span>
          <span>{"Reason"}</span>
          <span />
        </div>
      )}

      {closures.map((closure, index) => (
        <div
          key={closure.id ?? `new-${index}`}
          data-cy="temporary-closure"
          className="listing-status__temporary-closures__single-closure"
        >
          <TemporaryClosure
            rowLabel={`closure ${index + 1}`}
            idPrefix={`closure-${index}`}
            startDate={closure.start_date}
            endDate={closure.end_date}
            reason={closure.reason || "other"}
            setStartDate={(d) => update(index, {...closure, start_date: d})}
            setEndDate={(d) => update(index, {...closure, end_date: d})}
            setReason={(r) => update(index, {...closure, reason: r})}
          />
          <Buttons.DeleteButton
            cy="remove-closure"
            ariaLabel={`Remove closure ${index + 1}`}
            onDelete={() => remove(index)}
          />
        </div>
      ))}
    </div>
  );
};

export default TemporaryClosures;
